import { useTranslation } from 'react-i18next';
import { IDialogProps } from '@cbridge-modules/dialog';
import { useDispatch } from '@cbridge-utils/react-redux';
import { FormDialog } from '@cbridge-tools/form';
import { CompactTextFieldControl } from '@cbridge-tools/field';
import { MarkupProfileAction, IMarkupProfile } from '@cbridge-packages/markup-profile';
import { useMarkupProfileFormSchema } from './schema/useMarkupProfileFormSchema';

function MarkupProfileFormDialog({ payload, open, onClose }: IDialogProps<IMarkupProfile, number | null>) {
  'use no memo'; //Used because otherwise, the validation of fields in the child component does not update

  const isCreateMode = !payload?.markupProfileId;

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const schema = useMarkupProfileFormSchema();

  const handleCloseWithoutChange = () => onClose(null);
  const handleCloseAfterChange = (id: IMarkupProfile['markupProfileId']) => onClose(id);

  const handleSubmit = async (data: IMarkupProfile) => {
    if (isCreateMode) {
      dispatch(MarkupProfileAction.create.started({
        payload: data,
        resolve: handleCloseAfterChange,
      }));
    } else {
      dispatch(MarkupProfileAction.update.started({
        payload: data,
        resolve: handleCloseAfterChange,
      }));
    }
  };

  const title = isCreateMode
    ? t('text:configPage.markups.dialog.create.title')
    : t('text:configPage.markups.dialog.rename.title');

  return (
    <FormDialog
      open={open}
      onClose={handleCloseWithoutChange}
      onSubmit={handleSubmit}
      title={title}
      schema={schema}
      isCreateMode={isCreateMode}
      values={payload}
    >
      <CompactTextFieldControl<IMarkupProfile, 'markupProfileName'>
        name={'markupProfileName'}
        label={t('text:entity.markupProfile.profileName.label')}
        required={true}
      />
    </FormDialog>
  );
}

export { MarkupProfileFormDialog };
